module.exports = __webpack_public_path__ + "img/read-img2.3c12d158.png";